import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Col, Form, Row } from "react-bootstrap";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomPhoneInput from "../../../CustomControls/CustomPhoneInput";
import { post } from "../../../helpers/api_helper";
import { Spin } from "antd";
import CustomTextArea from "../../../CustomControls/CustomTextArea";
import {
  POST_GetCategoryDropDownListByCategoryType,
  POST_GetSupplierDetailByID,
  POST_SupplierInsert,
  POST_SupplierUpdate,
} from "../../../helpers/url_helper";
import {
  successMessage,
  errorMessage,
  validateMobileNoField,
  capitalizeString,
  warningMessage,
  validateEmailField,
} from "../CommonFunctions";
import CustomSelect from "../../../CustomControls/CustomSelect";
import QuickAddCategory from "../Categories/QuickAddCategory";

const AddSupplier = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { PrimaryIdParam } = useParams();
  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  const [cityOptions, setCityOptions] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [showQuickAddCategoryModal, setShowQuickAddCategoryModal] =
    useState(false);
  const [categoryType, setCategoryType] = useState(0);
  const [parentCategoryID, setParentCategoryID] = useState(0);
  const [categoryTypeName, setCategoryTypeName] = useState("");

  const validationSchema = Yup.object().shape({
    SupplierName: Yup.string()
      .trim()
      .required("Supplier Name is required field"),
    CountryID: Yup.string().trim().required("Country is required field"),
    StateID: Yup.string().trim().required("State is required field"),
    CityID: Yup.string().trim().required("City is required field"),
    PinCode: Yup.string().trim().required("Pincode is required field"),
    Address: Yup.string().trim().required("Address is required field"),
    ContactPerson: Yup.string()
      .trim()
      .required("Contact Person is required field"),
    MobileNo: Yup.string().required("Mobile No is required field"),
    EmailID: Yup.string().trim().required("Email is required field"),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      SupplierIDEncrypt: PrimaryIdParam ? window.atob(PrimaryIdParam) : "",
      SupplierCode: "",
      SupplierName: "",
      Address: "",
      MobileNoCountryCode: "+91",
      MobileNo: "",
      CityID: "",
      CityName: "",
      StateID: "",
      StateName: "",
      CountryID: "",
      PinCode: "",
      PhoneNo1CountryCode: "+91",
      PhoneNo1: "",
      PhoneNo2CountryCode: "+91",
      PhoneNo2: "",
      ContactPerson: "",
      MobileNoFormat: "",
      EmailID: "",
      WebAddress: "",
      PanNo: "",
      GSTINNo: "",
      TANNo: "",
      AadharNo: "",
      CINNo: "",
      SMSMobileNo1CountryCode: "+91",
      SMSMobileNo1: "",
      SMSMobileNo2CountryCode: "+91",
      SMSMobileNo2: "",
      MailID1: "",
      MailID2: "",
      MailID3: "",
      MailID4: "",
      PaymentTerms: "",
    },
    validateOnBlur: false,
  });

  const {
    setFieldValue,
    values: {
      CityID,
      StateID,
      CountryID,
      MobileNoCountryCode,
      PhoneNo1CountryCode,
      PhoneNo2CountryCode,
      SMSMobileNo1CountryCode,
      SMSMobileNo2CountryCode,
      actionFlag,
    },
  } = formik;

  useEffect(() => {
    getCountryDDL();
    if (PrimaryIdParam) {
      getSupplierDetailsByID();
    }
  }, []);

  const getCountryDDL = async () => {
    setIsLoading(true);
    await post(POST_GetCategoryDropDownListByCategoryType, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CategoryType: 1, // 1 = Country
      ParentCategoryID: 0,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setCountryOptions(
            response?.List?.map((item) => ({
              label: item.CategoryName,
              value: item.CategoryID,
            })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getStateDDL = async (CountryID) => {
    setIsLoading(true);
    await post(POST_GetCategoryDropDownListByCategoryType, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CategoryType: 2, // 2 = State
      ParentCategoryID: CountryID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setStateOptions(
            response?.List?.map((item) => ({
              label: item.CategoryName,
              value: item.CategoryID,
            })),
          );
          if (
            response?.List?.length > 0 &&
            StateID &&
            response?.List?.filter((x) => x.CategoryID == StateID).length == 0
          ) {
            formik.setFieldValue("StateID", "");
            formik.setFieldValue("StateName", "");
          } else {
            if (
              response?.List?.length == 1 &&
              actionFlag == 0 //Add
            ) {
              formik.setFieldValue("StateID", response?.List[0].CategoryID);
              formik.setFieldValue("StateName", response?.List[0].CategoryName);
            }
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getCityDDL = async (StateID) => {
    setIsLoading(true);
    await post(POST_GetCategoryDropDownListByCategoryType, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CategoryType: 3, // 3 = City
      ParentCategoryID: StateID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setCityOptions(
            response?.List?.map((item) => ({
              label: item.CategoryName,
              value: item.CategoryID,
            })),
          );
          if (
            response?.List?.length > 0 &&
            CityID &&
            response?.List?.filter((x) => x.CategoryID == CityID).length == 0
          ) {
            formik.setFieldValue("CityID", "");
            formik.setFieldValue("CityName", "");
          } else {
            if (
              response?.List?.length == 1 &&
              actionFlag == 0 //Add
            ) {
              formik.setFieldValue("CityID", response?.List[0].CategoryID);
              formik.setFieldValue("CityName", response?.List[0].CategoryName);
            }
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (CountryID) {
      formik.setFieldError("CountryID", "");
      formik.setFieldTouched("CountryID", false);
      getStateDDL(CountryID);
    }
  }, [CountryID]);

  useEffect(() => {
    if (StateID) {
      formik.setFieldError("StateID", "");
      formik.setFieldTouched("StateID", false);
      getCityDDL(StateID);
    }
  }, [StateID]);

  const getSupplierDetailsByID = () => {
    setIsLoading(true);
    post(POST_GetSupplierDetailByID, {
      SupplierIDEncrypt: window.atob(PrimaryIdParam),
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setValues({
            ...response,
          });
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const handleValidSubmit = (values) => {
    if (
      !validateMobileNoField(
        values?.MobileNoFormat,
        MobileNoCountryCode,
        values?.MobileNo,
      )
    ) {
      formik.setFieldError("MobileNo", "Please enter a valid mobile number");
      formik.setFieldTouched("MobileNo", true);
      return false;
    }

    setIsLoading(true);

    let payload = {
      ...values,
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      CreatedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
      ModifiedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
    };

    post(PrimaryIdParam ? POST_SupplierUpdate : POST_SupplierInsert, payload)
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          successMessage(response?.Message);
          setTimeout(() => {
            navigate("/supplier");
          }, 1000);
        } else {
          errorMessage(response?.Message);
          setIsLoading(false);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const fnCallbackQuickAddCategory = (categoryID, categoryName) => {
    if (categoryType == 1) {
      // 1 = Country
      setCountryOptions([
        ...countryOptions,
        { label: categoryName, value: categoryID },
      ]);
      formik.setFieldValue("CountryID", categoryID);
      formik.setFieldValue("CountryName", categoryName);
    } else if (categoryType == 2) {
      // 2 = State
      setStateOptions([
        ...stateOptions,
        { label: categoryName, value: categoryID },
      ]);
      formik.setFieldValue("StateID", categoryID);
      formik.setFieldValue("StateName", categoryName);
    } else if (categoryType == 3) {
      // 3 = City
      setCityOptions([
        ...cityOptions,
        { label: categoryName, value: categoryID },
      ]);
      formik.setFieldValue("CityID", categoryID);
      formik.setFieldValue("CityName", categoryName);
    }
  };

  return (
    <>
      <div className="card m-1">
        <div className="card-body p-1">
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div className="tbl-caption p-2">
              <h4 className="heading mb-0">
                {PrimaryIdParam ? "Edit" : "Add"} Supplier
              </h4>
            </div>
            <hr className="mt-0 mb-1"></hr>
            <div className="p-2 pt-0">
              <FormikProvider value={formik}>
                <Form onSubmit={formik.handleSubmit}>
                  <Row>
                    <Col lg={12}>
                      <Row>
                        {PrimaryIdParam && (
                          <Col lg={3}>
                            <Field
                              label="Supplier Code"
                              name="SupplierCode"
                              placeholder={"Enter SupplierCode"}
                              component={CustomInput}
                              required
                              maxLength={250}
                              autoFocus
                              onChange={(e) => {
                                formik.setFieldValue(
                                  "SupplierCode",
                                  e?.target?.value,
                                );
                              }}
                              disabled
                            />
                          </Col>
                        )}
                        <Col lg={3}>
                          <Field
                            label="Supplier Name"
                            name="SupplierName"
                            placeholder={"Enter Supplier Name"}
                            component={CustomInput}
                            maxLength={150}
                            onChange={(e) => {
                              formik.setFieldValue(
                                "SupplierName",
                                capitalizeString(e?.target?.value),
                              );
                            }}
                            required
                          />
                        </Col>

                        <Col lg={3}>
                          <Field
                            label="Contact Person"
                            name="ContactPerson"
                            placeholder={"Enter Contact Person"}
                            component={CustomInput}
                            maxLength={150}
                            onChange={(e) => {
                              formik.setFieldValue(
                                "ContactPerson",
                                capitalizeString(e?.target?.value),
                              );
                            }}
                            required
                          />
                        </Col>

                        <Col lg={3}>
                          <Field
                            label={"Mobile No."}
                            type="text"
                            name="MobileNo"
                            placeholder={"Enter Mobile No."}
                            countryCode={MobileNoCountryCode}
                            component={CustomPhoneInput}
                            onChange={(value, { countryCode, dialCode }) => {
                              setFieldValue("CountryCode", dialCode);
                              setFieldValue(
                                "MobileNo",
                                value.substring(dialCode.toString().length),
                              );
                            }}
                            onFocus={(value, { format }) => {
                              setFieldValue("MobileNoFormat", format);
                            }}
                            required
                          />
                        </Col>
                      </Row>

                      <Row>
                        <Col lg={3}>
                          <Field
                            label="Address"
                            name="Address"
                            rows={5}
                            placeholder={"Enter Address"}
                            component={CustomTextArea}
                            maxLength={500}
                            required
                            style={{ maxHeight: "92px !important" }}
                          />
                        </Col>
                        <Col lg={9}>
                          <Row>
                            <Col lg={4}>
                              <Link
                                to="#"
                                className="icon-box icon-box-md bg-primary-light me-1"
                                title="New Country"
                                style={{ float: "right" }}
                                onClick={() => {
                                  setCategoryType(1); // 1 = Country
                                  setCategoryTypeName("Country");
                                  setParentCategoryID(0);
                                  setShowQuickAddCategoryModal(true);
                                }}
                              >
                                <i className="fa fa-plus"></i>
                              </Link>

                              <Field
                                label="Country"
                                name="CountryID"
                                placeholder={"Select Country"}
                                component={CustomSelect}
                                options={countryOptions}
                                required
                                onChange={(e) => {
                                  setStateOptions([]);
                                  formik.setFieldValue("StateID", "");
                                  formik.setFieldValue("StateName", "");
                                  setCityOptions([]);
                                  formik.setFieldValue("CityID", "");
                                  formik.setFieldValue("CityName", "");

                                  formik.setFieldValue(
                                    "CountryID",
                                    e?.value ?? "",
                                  );
                                  formik.setFieldValue(
                                    "CountryName",
                                    e?.label ?? "",
                                  );
                                }}
                              />
                            </Col>
                            <Col lg={4}>
                              <Link
                                to="#"
                                className="icon-box icon-box-md bg-primary-light me-1"
                                title="New State"
                                style={{ float: "right" }}
                                onClick={() => {
                                  if (CountryID) {
                                    setCategoryType(2); // 2 = State
                                    setCategoryTypeName("State");
                                    setParentCategoryID(CountryID);
                                    setShowQuickAddCategoryModal(true);
                                  } else {
                                    warningMessage(
                                      "Please select Country first...",
                                    );
                                  }
                                }}
                              >
                                <i className="fa fa-plus"></i>
                              </Link>

                              <Field
                                label="State"
                                name="StateID"
                                placeholder={"Select State"}
                                component={CustomSelect}
                                options={stateOptions}
                                required
                                onChange={(e) => {
                                  setCityOptions([]);
                                  formik.setFieldValue("CityID", "");
                                  formik.setFieldValue("CityName", "");

                                  formik.setFieldValue(
                                    "StateID",
                                    e?.value ?? "",
                                  );
                                  formik.setFieldValue(
                                    "StateName",
                                    e?.label ?? "",
                                  );
                                }}
                              />
                            </Col>
                            <Col lg={4}>
                              <Link
                                to="#"
                                className="icon-box icon-box-md bg-primary-light me-1"
                                title="New City"
                                style={{ float: "right" }}
                                onClick={() => {
                                  if (StateID) {
                                    setCategoryType(3); // 3 = City
                                    setCategoryTypeName("City");
                                    setParentCategoryID(StateID);
                                    setShowQuickAddCategoryModal(true);
                                  } else {
                                    warningMessage(
                                      "Please select State first...",
                                    );
                                  }
                                }}
                              >
                                <i className="fa fa-plus"></i>
                              </Link>

                              <Field
                                label="City"
                                name="CityID"
                                placeholder={"Select City"}
                                component={CustomSelect}
                                options={cityOptions}
                                required
                                onChange={(e) => {
                                  formik.setFieldError("CityID", "");
                                  formik.setFieldTouched("CityID", false);
                                  formik.setFieldValue(
                                    "CityID",
                                    e?.value ?? "",
                                  );
                                  formik.setFieldValue(
                                    "CityName",
                                    e?.label ?? "",
                                  );
                                }}
                              />
                            </Col>
                            <Col lg={4}>
                              <Field
                                type="text"
                                label="PinCode"
                                name="PinCode"
                                placeholder={"Enter Pincode"}
                                component={CustomInput}
                                maxLength={6}
                                required
                                onInput={(e) => {
                                  e.target.value = e.target.value.replace(
                                    /[^0-9]/g,
                                    "",
                                  );
                                }}
                              />
                            </Col>
                            <Col lg={4}>
                              <Field
                                label={"Phone No 1"}
                                type="text"
                                name="PhoneNo1"
                                placeholder={"Enter Phone No 1"}
                                countryCode={PhoneNo1CountryCode}
                                component={CustomPhoneInput}
                                onChange={(
                                  value,
                                  { countryCode, dialCode },
                                ) => {
                                  setFieldValue(
                                    "PhoneNo1CountryCode",
                                    dialCode,
                                  );
                                  setFieldValue(
                                    "PhoneNo1",
                                    value.substring(dialCode.toString().length),
                                  );
                                }}
                                onFocus={(value, { format }) => {
                                  setFieldValue("MobileNoFormat", format);
                                }}
                              />
                            </Col>

                            <Col lg={4}>
                              <Field
                                label={"Phone No 2"}
                                type="text"
                                name="PhoneNo2"
                                placeholder={"Enter Phone No 2"}
                                countryCode={PhoneNo2CountryCode}
                                component={CustomPhoneInput}
                                onChange={(
                                  value,
                                  { countryCode, dialCode },
                                ) => {
                                  setFieldValue(
                                    "PhoneNo2CountryCode",
                                    dialCode,
                                  );
                                  setFieldValue(
                                    "PhoneNo2",
                                    value.substring(dialCode.toString().length),
                                  );
                                }}
                                onFocus={(value, { format }) => {
                                  setFieldValue("MobileNoFormat", format);
                                }}
                              />
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                    <Col lg={3}>
                      <Field
                        type="email"
                        label={"Email"}
                        name="EmailID"
                        placeholder={"Enter Email"}
                        component={CustomInput}
                        maxLength={100}
                        required
                        validate={validateEmailField}
                      />
                    </Col>
                    <Col lg={3}>
                      <Field
                        label="Web Address"
                        name="WebAddress"
                        placeholder={"Enter Web Address"}
                        component={CustomInput}
                        maxLength={500}
                      />
                    </Col>
                    <Col lg={3}>
                      <Field
                        label="Pan No"
                        name="PanNo"
                        placeholder={"Enter Pan No"}
                        component={CustomInput}
                        maxLength={15}
                        onInput={(e) => {
                          e.target.value = e.target.value.toUpperCase();
                        }}
                      />
                    </Col>
                    <Col lg={3}>
                      <Field
                        label="GSTIN No"
                        name="GSTINNo"
                        placeholder={"Enter GSTIN No"}
                        component={CustomInput}
                        maxLength={50}
                      />
                    </Col>
                    <Col lg={3}>
                      <Field
                        label="TAN No"
                        name="TANNo"
                        placeholder={"Enter TAN No"}
                        component={CustomInput}
                        maxLength={50}
                      />
                    </Col>
                    <Col lg={3}>
                      <Field
                        type="text"
                        label="Aadhar No"
                        name="AadharNo"
                        placeholder={"Enter Aadhar No"}
                        component={CustomInput}
                        maxLength={20}
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            "",
                          );
                        }}
                      />
                    </Col>
                    <Col lg={3}>
                      <Field
                        label="CIN No"
                        name="CINNo"
                        placeholder={"Enter CIN No"}
                        component={CustomInput}
                        maxLength={50}
                      />
                    </Col>
                    <Col lg={3}>
                      <Field
                        label={"SMS Mobile - 1"}
                        type="text"
                        name="SMSMobileNo1"
                        placeholder={"Enter SMS Mobile 1"}
                        countryCode={SMSMobileNo1CountryCode}
                        component={CustomPhoneInput}
                        onChange={(value, { countryCode, dialCode }) => {
                          setFieldValue("SMSMobileNo1CountryCode", dialCode);
                          setFieldValue(
                            "SMSMobileNo1",
                            value.substring(dialCode.toString().length),
                          );
                        }}
                        onFocus={(value, { format }) => {
                          setFieldValue("MobileNoFormat", format);
                        }}
                      />
                    </Col>

                    <Col lg={3}>
                      <Field
                        label={"SMS Mobile - 2"}
                        type="text"
                        name="SMSMobileNo2"
                        placeholder={"Enter SMS Mobile 2"}
                        countryCode={SMSMobileNo2CountryCode}
                        component={CustomPhoneInput}
                        onChange={(value, { countryCode, dialCode }) => {
                          setFieldValue("SMSMobileNo2CountryCode", dialCode);
                          setFieldValue(
                            "SMSMobileNo2",
                            value.substring(dialCode.toString().length),
                          );
                        }}
                        onFocus={(value, { format }) => {
                          setFieldValue("MobileNoFormat", format);
                        }}
                      />
                    </Col>

                    <Col lg={3}>
                      <Field
                        type="email"
                        label={"Mail ID - 1"}
                        name="MailID1"
                        placeholder={"Enter Mail ID - 1"}
                        component={CustomInput}
                        maxLength={100}
                        validate={validateEmailField}
                      />
                    </Col>
                    <Col lg={3}>
                      <Field
                        type="email"
                        label={"Mail ID - 2"}
                        name="MailID2"
                        placeholder={"Enter Mail ID - 2"}
                        component={CustomInput}
                        maxLength={100}
                        validate={validateEmailField}
                      />
                    </Col>
                    <Col lg={3}>
                      <Field
                        type="email"
                        label={"Mail ID - 3"}
                        name="MailID3"
                        placeholder={"Enter Mail ID - 3"}
                        component={CustomInput}
                        maxLength={100}
                        validate={validateEmailField}
                      />
                    </Col>
                    <Col lg={3}>
                      <Field
                        type="email"
                        label={"Mail ID - 4"}
                        name="MailID4"
                        placeholder={"Enter Mail ID - 4"}
                        component={CustomInput}
                        maxLength={100}
                        validate={validateEmailField}
                      />
                    </Col>
                    <Col lg={3}>
                      <Field
                        label="Payment Terms"
                        name="PaymentTerms"
                        placeholder={"Enter Payment Terms"}
                        component={CustomInput}
                        maxLength={500}
                      />
                    </Col>
                  </Row>
                  <hr className="mt-1 mb-2"></hr>
                  <button type="submit" className="btn btn-primary btn-sm me-2">
                    <i className="fa-solid fa-floppy-disk"></i> Submit
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger btn-sm"
                    onClick={(e) => {
                      navigate(-1);
                    }}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </button>
                </Form>
              </FormikProvider>
            </div>
          </Spin>
          <QuickAddCategory
            categoryType={categoryType}
            parentCategoryID={parentCategoryID}
            showModal={showQuickAddCategoryModal}
            setShowModal={setShowQuickAddCategoryModal}
            categoryTypeName={categoryTypeName}
            fnCallback={fnCallbackQuickAddCategory}
          />
        </div>
      </div>
    </>
  );
};

export default AddSupplier;
